// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Added v8 — see `ChannelModifier.schema_version`.
 *
 * Which floor an expected step or a precondition compares against under the
 * `SAME_POSITION` scopes, and which floor a `SEND` step sends to.
 *   `PAYLOAD` (0) — the modifier payload's floor, after its value transform:
 *                   the pre-v8 behaviour, so it MUST stay 0.
 *   `SOURCE` (1)  — the floor of the command that triggered the modifier.
 * Values are APPEND-ONLY.
 */
export enum StepPositionSource {
  PAYLOAD = 0,
  SOURCE = 1,
}
